export const PermissionNames = {
  MenuDashboard: 'Menu.Dashboard',
  Registers: {
    MenuRegisters: 'Menu.Registers',
    MenuProperty: 'Menu.Registers.Property',
    MenuProductionPlanning: 'Menu.Registers.ProductionPlanning',
    MenuPacking: 'Menu.Registers.Packaging',
    MenuProductorPreferences: 'Menu.Registers.ProducerPreferences',
    MenuStock: 'Menu.Registers.Stock',
    MenuExpedition: 'Menu.Registers.Expedition',
    MenuShippingCompany: 'Menu.Registers.ShippingCompany',
    MenuSiteDecorators: 'Menu.Registers.ManageDecorators',
    MenuPLP: 'Menu.Registers.PLP',
    MenuProductRegistrationRequest: 'Menu.Registers.ManageProductRegistration',
  },
  Commercial: {
    MenuCommercial: 'Menu.CommercialManager',
    MenuAutoservice: 'Menu.CommercialManager.SelfService',
    MenuManagementEcommerce: 'Menu.CommercialManager.PreferencesOfferChannels',
    MenuBackoutDates: 'Menu.CommercialManager.UnavailableDatesEcommerce',
  },
  Announcements: {
    MenuAnnouncements: 'Menu.Announcements',
    MenuAnnouncementsList: 'Menu.Announcements.AnnouncementsList',
  },
  Quality: {
    MenuQuality: 'Menu.Quality',
    MenuTechnicalSpecification: 'Menu.Quality.TechnicalSpecification',
    MenuProductBarCode: 'Menu.Quality.ProductBarCode',
    MenuOrderBarCode: 'Menu.Quality.OrderBarCode',
  },
  QualityManager: {
    MenuQuality: 'Menu.QualityManager',
    MenuCompetence: 'Menu.QualityManager.Competence',
  },
  Gfp: {
    MenuGFP: 'Menu.GFP',
    MenuGFP2: 'Menu.GFP.GFP',
    MenuTagCart: 'Menu.GFP.TagCart',
    MenuOrders: 'Menu.GFP.Orders',
    MenuAcceptanceTerms: 'Menu.GFP.AcceptanceTerms',
    MenuAuthorization: 'Menu.GFP.Authorization',
    MenuWithheldGfp: 'Menu.GFP.WithheldGfp',
    MenuGfpBatch: 'Menu.GFP.Batch',
    MenuExpeditionManagement: 'Menu.GFP.ExpeditionManagement',
    MenuGfpPrintingExpedition: 'Menu.GFP.GfpPrintingExpedition'
  },
  Images: {
    ProductRealPhotos: 'Menu.Images.ProductRealPhotos'
  },
  Offers: {
    MenuOffers: 'Menu.Offers',
    MenuVouchers: 'Menu.Offers.Voucher',
    MenuVolLkp: 'Menu.Offers.RegisterOffer',
  },
  MarketingManagement: {
    MenuMarketingManagement: 'Menu.MarketingManager',
    MenuRegisterAnnouncement: 'Menu.MarketingManager.Announcements',
    MenuProducerPage: 'Menu.MarketingManager.ProducerPage',
  },
  ProducerManagement: {
    MenuProducerManagement: 'Menu.ProducerManager',
    MenuProducerPageManagement: 'Menu.ProducerManager.ProducerPage',
  },
  Reports: {
    MenuReports: 'Menu.Reports',
    MenuOfferReport: 'Menu.Reports.SalesReport',
    MenuOfferReportEcommerce: 'Menu.Reports.SalesReportEcommerce',
    MenuAnnouncementReports: 'Menu.Reports.Announcement',
    MenuPriceReport: 'Menu.Reports.Price',
    MenuKlokDrawReport: 'Menu.Reports.KlokDraw',
    MenuDetailedStock: 'Menu.Reports.DetailedStock',
    MenuAgreement: 'Menu.Reports.Agreement',
    MenuProductCatalog: 'Menu.Reports.ProductCatalog',
    MenuCustomerCatalog: 'Menu.Reports.CustomerCatalog',
    MenuSalesStatement: 'Menu.Reports.SalesStatement',
    MenuSalesStatementByType: 'Menu.Reports.SalesStatementByType',
  },
  Orders: {
    MenuOrders: 'Menu.Orders',
    MenuOrder: 'Menu.Orders.Visualize',
    MenuOrdersToCollect: 'Menu.Orders.OrderToCollect',
    MenuTagPrintingList: 'Menu.Orders.TagPrintList',
    MenuOrdersGfp: 'Menu.Orders.OrdersGfp',
    MenuKlokReservation: 'Menu.Orders.KlokReservation',
  },
  MenuIndicatorsPanel: 'Menu.IndicatorsPanel',
  TiManagement: {
    MenuTiManagement: 'Menu.ITManager',
    MenuBIdashboard: 'Menu.ITManager.BiDashboard',
  },
  RfidReports: {
    MenuRfidReports: 'Menu.RfidReports',
    MenuInventory: 'Menu.RfidReports.Inventory',
    MenuReceipt: 'Menu.RfidReports.Receipt',
    MenuExpedition: 'Menu.RfidReports.Expedition',
    MenuMovement: 'Menu.RfidReports.Movement',
  },
};
